export interface VehicleActionTypes {
  type: VehicleActions;
  payload?: any;
}

export enum VehicleActions {
  CREATE_VEHICLE = "CREATE_VEHICLE",
  GET_VEHICLE_LIST = "GET_VEHICLE_LIST",
  SET_VEHICLE_LIST = "SET_VEHICLE_LIST",
  SET_VEHICLE_LIST_PAGE_COUNT = "SET_VEHICLE_LIST_PAGE_COUNT",
  GET_VEHICLE_DATA_BY_ID = "GET_VEHICLE_DATA_BY_ID",
  SET_VEHICLE_DATA_BY_ID = "SET_VEHICLE_DATA_BY_ID",
  EDIT_VEHICLE_DATA_BY_ID = "EDIT_VEHICLE_DATA_BY_ID",
}